module.exports = __webpack_public_path__ + "img/orange.ca7db12b.png";